import { ApiType } from "@gymflow/common";
import { zonedTimeToUtc } from "@gymflow/helpers";
import { useMutation } from "@tanstack/react-query";

export const useMutationSendSMSToLeadsFilter = ({
  api,
  tz,
}: {
  api: ApiType;
  tz: string;
}) => {
  return useMutation({
    mutationFn: async (
      payload: Parameters<ApiType["smsApi"]["sendSMSToLeadsFilter"]>[0],
    ) => {
      const parsedOpts = { ...payload };
      if (payload?.createdFrom) {
        parsedOpts.createdFrom = zonedTimeToUtc(payload.createdFrom, tz);
      }
      if (payload?.createdTo) {
        parsedOpts.createdTo = zonedTimeToUtc(payload.createdTo, tz);
      }

      return (await api.smsApi.sendSMSToLeadsFilter(parsedOpts)).data;
    },
  });
};
